// ##### 25-02-05 Komarov
import { Input } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-14
const ExcursionComponent = ({ props }) => {
  const { AddExcursionComments, excursionComments, maxLength } = props;
  // ##### Komarov 2025-08-05
  const excursionCommentsMessage = useLocalizedText('Excursion');
  // ##### 23-10-17 Komarov
  const { TextArea } = Input;

  return (
    <div key={uniqueId()} className="form-block-lf">
      <span>{excursionCommentsMessage}</span>
      <TextArea
        rows={1}
        maxLength={maxLength}
        style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }}
        onChange={AddExcursionComments}
        value={excursionComments}
      />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default ExcursionComponent;
